import type { GetMarketBoostEventsRow } from '@morfi/backend-sdk-v2/client';
import { isoToTimestamp } from './sdk-mapping';
import type { BoostEvent } from './types';

interface BoostEventMapping {
  events: BoostEvent[];
  invalidRowCount: number;
}

export function mapBoostEventRows(rows: ReadonlyArray<GetMarketBoostEventsRow>): BoostEventMapping {
  const events: BoostEvent[] = [];
  let invalidRowCount = 0;

  for (const [index, row] of rows.entries()) {
    const time = isoToTimestamp(row.timestamp ?? '');
    const amountD6 = row.amount ?? '';
    const boosterAddress = row.boosterPubkey ?? '';
    if (!Number.isFinite(time) || !/^\d+$/.test(amountD6) || boosterAddress.length === 0) {
      invalidRowCount += 1;
      continue;
    }

    const eventId = row.eventId?.trim();
    events.push({
      id:
        eventId !== undefined && eventId.length > 0
          ? eventId
          : `legacy:${boosterAddress}:${String(time)}:${amountD6}:${String(index)}`,
      time,
      outcomeIndex: 0,
      amountD6,
      boosterAddress,
      boosterDisplayName: null,
      boosterHandle: null,
    });
  }

  return { events, invalidRowCount };
}
